import { apiFetch } from './client.js';

// #401 — the staff half of the legal acceptance gate.
//
// The manifest of current document versions lives on the SERVER
// (deploy/legal/versions.json, read by apps/api/src/lib/legal-versions.ts) and
// is never shipped to the browser. This client only asks what is outstanding
// and posts back the exact pairs it was given, which is what makes a bundle
// left open across a version bump safe: the POST names versions the server no
// longer considers current, and comes back 409 instead of recording agreement
// to text nobody was shown.

export interface LegalDocument {
  slug: string;
  title: string;
  /** Absolute path of the public page, e.g. /legal/terms.html — served by nginx, outside this bundle. */
  path: string;
  version: string;
}

export interface AcceptanceStatus {
  /**
   * Whether this caller is subject to the gate. Always true on the staff
   * surface — every staff token is a browser login with a person behind it.
   * The customer intake copy of this endpoint answers false for a machine
   * credential, and the field is shared so the two surfaces read the same.
   */
  gated: boolean;
  /** Current documents with no acceptance on record for this principal. */
  pending: LegalDocument[];
}

export async function fetchLegalAcceptance(): Promise<AcceptanceStatus> {
  return apiFetch<AcceptanceStatus>('/me/legal-acceptance');
}

/**
 * Records acceptance of exactly these documents. Answers the same status shape
 * so the caller can simply re-render from the response.
 */
export async function acceptLegalDocuments(documents: LegalDocument[]): Promise<AcceptanceStatus> {
  return apiFetch<AcceptanceStatus>('/me/legal-acceptance', {
    method: 'POST',
    body: JSON.stringify({
      documents: documents.map((d) => ({ slug: d.slug, version: d.version })),
    }),
  });
}
